import { useEffect, useState } from "react";
import { ReactComponent as IconTimes } from "assets/images/icons/project-icons/times.svg"
import FormDrawer from "components/__new/common/form-drawer";
import { Input, SelectInput } from "components/__new/common/form";
import { useDispatch, useSelector } from "react-redux";
import * as banksActions from "store/ui/banks/action";
import useBanks from "hooks/useBanks";
import useLoginInfo from "hooks/useLoginInfo";


const CsvEntryEditModal = ({isOpen, setIsOpen, selectedItem, updateCsvEntry}) => {
    const dispatch  = useDispatch();
    const {userInfo} = useLoginInfo();
    const { banks, banksLoading } = useBanks(userInfo?.token);
    const [isConfirmEditOpen, setIsConfirmEditOpen] = useState(false);
    
    const [form, setForm] = useState({
        accountName: "",
        accountNumber: "",
        bankName: "",
        bankCode: "",
        amount: "",
        narration: "",
    });
    
    const onSubmit = () => {
        updateCsvEntry(form);
        setForm({});
        setIsOpen(false);
    }
    
    const updateBank = (e) => {
        const bankItem = banks?.find((item) => item.code === e.target.value)
        
        setForm({
            ...form,
            bankName: bankItem?.bankName || bankItem?.institutionName,
            bankCode: bankItem?.bankCode || bankItem?.institutionCode,
        });        
    }
    
    useEffect(() => {
        if(selectedItem?.accountName?.length > 0) {
            setForm({...selectedItem});
        }
    }, [selectedItem])
    
    
    useEffect(() => {
        dispatch(banksActions.getAllBanks());
        // eslint-disable-next-line
    }, [])
    
    return (
        <>
            <SaveEditsModal 
                isOpen={isConfirmEditOpen}
                setIsOpen={setIsConfirmEditOpen}
                onProceed={() => {
                    setIsConfirmEditOpen(false);
                    onSubmit();
                }}
            />
            
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={() => {}}>
                <div className='w-full p-7'>
                    <div className='mb-6'>
                        <div className="flex items-center justify-between">
                            <div className="text-xl font-bold">
                                Edit This Entry
                            </div>
                            
                            <div onClick={() => setIsOpen(false)} className='w-7 h-7 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                                <IconTimes width={30} />
                            </div>
                        </div>
                    </div>
                    
                    
                    <div className="w-full space-y-3">
                        <div className="form-group">
                            <label>Account Name</label>
                            
                            <input
                                className="form-input"
                                value={form?.accountName || ""}
                                onChange={(e) => setForm({...form, accountName: e.target.value})}
                            />
                        </div>
                        
                        
                        <div className="form-group">
                            <label>Account Number</label>
                            
                            <input
                                id="prl-input"
                                className="form-input"
                                value={form?.accountNumber || ""}
                                onChange={(e) => setForm({...form, accountNumber: e.target.value})}
                            />
                        </div>
                        
                        <SelectInput disabled={banksLoading} label="Bank Name" value={form?.bankCode} onChange={(e) => updateBank(e)}>
                            <option value="">{banksLoading ? "Fetching banks..." : "Select Bank"}</option>
                            {banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map(bank => (
                                <option key={bank?.bankId || bank?.id} value={bank?.bankCode || bank?.institutionCode}>{bank?.bankName || bank?.institutionName}</option>
                            ))}
                        </SelectInput>
                        
                        <div className="form-group relative">
                            <label>amount (Naira)</label>
                            <input
                                type="number"
                                id="prl-input"
                                className="form-input !pl-7"
                                value={form?.amount || ""}
                                placeholder="0.00"
                                onChange={(e) => setForm({...form, amount: e.target.value})}
                            />
                            
                            <div className="absolute left-3 top-7">₦&nbsp;</div>
                        </div>
                        
                        <Input
                            type="text"
                            label="Narration"
                            value={form?.narration || ""}
                            className="form-input"
                            placeholder="Narration"
                            onChange={(e) => setForm({...form, narration: e.target.value})}
                        />
                    </div>
                    
                    <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                        <button onClick={() => setIsOpen(false)} className="btn btn-transparent-primary mr-3">
                            Cancel
                        </button>
                        
                        <button onClick={() => setIsConfirmEditOpen(true)} className="btn btn-ep-primary">
                            Save Changes
                        </button>
                    </div>
                </div>
            </FormDrawer>
        </>
    )
}

const SaveEditsModal = ({isOpen, setIsOpen, onProceed}) => {

return (
    <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={() => {}}>
        <div className="p-7 pb-4">
            <div className='pb-2 mb-2'>
                <div className="flex items-center justify-between">
                    <div className="font-bold">
                        Save All Changes
                    </div>
                    
                    <div onClick={() => setIsOpen(false)} className='w-5 h-5 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                        <IconTimes width={10} />
                    </div>
                </div>
                
                
                <div className="my-5 text-ep-gray-600">
                    Are you sure you want to perform this action?
                </div>
                
                
                <div className="w-full flex items-center justify-center">
                    <button onClick={() => setIsOpen(false)} className="btn btn-transparent-primary w-2/4 mr-3">
                        No
                    </button>
                    
                    <button onClick={onProceed} className="btn btn-ep-primary w-2/4">
                        Yes
                    </button>
                </div>
            </div>
        </div>
    </FormDrawer>
    )
}

export default CsvEntryEditModal;